export default "__VITE_PUBLIC_ASSET__a5182a1c__"